"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _BlockButton = _interopRequireDefault(require("./BlockButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const CarouselSlide = (_ref) => {
  let {
    active,
    animateIn,
    animateOut,
    direction,
    index,
    onCarouselClick,
    showZoomOverlay,
    zoomOverlayContent
  } = _ref,
      props = _objectWithoutProperties(_ref, ["active", "animateIn", "animateOut", "direction", "index", "onCarouselClick", "showZoomOverlay", "zoomOverlayContent"]);

  const [currentDirection, setDirection] = (0, _react.useState)(null);
  const [classes, setClasses] = (0, _react.useState)({});
  const startAnimation = (0, _react.useCallback)(() => {
    const newDirection = direction === 'prev' ? 'right' : 'left';
    setDirection(newDirection);
  }, [direction, setDirection]);
  (0, _react.useEffect)(() => {
    const initialClasses = {
      item: true,
      clickable: onCarouselClick && active && !animateIn,
      active: active && !animateIn || animateOut,
      'overlay-container': showZoomOverlay
    };

    if (direction && active && animateIn) {
      initialClasses[direction] = true;
    }

    if (currentDirection && (animateIn || animateOut)) {
      initialClasses[currentDirection] = true;
    }

    setClasses(initialClasses);
  }, [onCarouselClick, active, animateIn, animateOut, showZoomOverlay, direction, currentDirection]);
  (0, _react.useEffect)(() => {
    setDirection(null);
    setTimeout(() => startAnimation(), 20);
  }, [active, startAnimation]);

  const onClick = () => {
    onCarouselClick && onCarouselClick(index);
  };

  const zoomContent = zoomOverlayContent || /*#__PURE__*/_react.default.createElement("span", null, "Zoom In");

  return /*#__PURE__*/_react.default.createElement(_BlockButton.default, {
    onClick: onClick,
    className: (0, _emotion.cx)(classes)
  }, props.children, showZoomOverlay ? /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay flex-center",
    style: {
      color: '#006F8A'
    }
  }, zoomContent) : null);
};

CarouselSlide.propTypes = {
  active: _propTypes.default.bool,
  index: _propTypes.default.number,
  animateOut: _propTypes.default.bool,
  animateIn: _propTypes.default.bool,
  direction: _propTypes.default.string,
  onCarouselClick: _propTypes.default.func,
  showZoomOverlay: _propTypes.default.bool,
  zoomOverlayContent: _propTypes.default.node,
  children: _propTypes.default.node
};
var _default = CarouselSlide;
exports.default = _default;